<template>
    <div
        @click="onClick"
        class="modal-button"
        :style="{ background: $Utils.colors[color] }"
        :class="{ '-disabled': disabled, '-blocked': blocked }"
    >
        <transition name="fade" mode="out-in">
            <div class="button-loader" v-if="loading">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div v-else v-text="$t(title)" />
        </transition>
    </div>
</template>
<script>
export default {
    props: {
        title: String,
        loading: Boolean,
        blocked: Boolean,
        disabled: { type: Boolean, default: false },
        color: {
            type: String,
            default: ''
        }
    },
    methods: {
        onClick($event) {
            if (this.disabled) {
                return
            }
            this.$emit('click', $event)
        }
    }
}
</script>
<style lang="scss" scoped>
.modal-button {
    margin-top: 1rem;
    border-radius: $input-radius;
    width: 100%;
    font-size: 1.2rem;
    font-family: $input-family;
    cursor: pointer;
    transition: $ease;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    background: $action-accent;
    height: 3rem;
    user-select: none;

    &:hover {
        transform: $translateY;
    }

    &.-disabled {
        background-color: grey;
        pointer-events: none;
    }
    &.-blocked {
        color: $accent-label;
        border-color: $accent-label;
        cursor: default;

        &:hover {
            transform: none;
        }
    }
}
.button-loader {
    div {
        color: red;
        background: #fff;
    }
}
.button-loader {
    width: 64px;
    height: 11px;

    display: inline-block;
    position: absolute;
}

.button-loader div {
    position: absolute;
    top: 0;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.button-loader div:nth-child(1) {
    left: 6px;
    animation: button-loader1 0.6s infinite;
}

.button-loader div:nth-child(2) {
    left: 6px;
    animation: button-loader2 0.6s infinite;
}

.button-loader div:nth-child(3) {
    left: 26px;
    animation: button-loader2 0.6s infinite;
}

.button-loader div:nth-child(4) {
    left: 45px;
    animation: button-loader3 0.6s infinite;
}
@keyframes button-loader1 {
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
}

@keyframes button-loader3 {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(0);
    }
}

@keyframes button-loader2 {
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(19px, 0);
    }
}
</style>
